import { getMessages } from 'locale'

export const NAMESPACE = 'KanBo/locale/'
export const SET_LANG = NAMESPACE + 'SET_LANG'

const initialState = {
  lang: 'en-US',
  messages: getMessages('en-US')
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET_LANG:
      return {
        ...state,
        lang: action.payload.lang,
        messages: getMessages(action.payload.lang)
      }
    default: return state
  }
}

export function setLang ({ lang }) {
  return {
    type: SET_LANG,
    payload: {
      lang
    }
  }
}
